export default {

  //  Registration
  create_account: 'Create account',
  email: 'EMAIL',
  phone_number: 'PHONE NUMBER',
  sign_up: 'SIGN UP',
  verification: 'Account verification',
  verify: 'CONTINUE',
  account_verify: 'We send you a sms with a code to activate your account',
  email_verify: 'Please enter your email',
  email_format: 'Please enter correct email in format abc@mail.com',
  phone_verify: 'Please enter your phone number',
  reactivate: 'We send you a sms with a code to reactivate your account',
  code: 'CODE',

  //  Main
  start_button: 'START',
  address_counry: 'Danielgoedkoopstraat 13A, Amsterdam',
  hours:'HOURS',
  minutes:'MINUTES',
  hours_h:'h',
  minutes_min:'min',
  parking_time:'Parking time',
  yellow_button_top_text:'You only pay for the actual parking time',
  new_balance:'NEW BALANCE',
  reserved_amount:'RESERVED AMOUNT',
  license_plate:'LICENSE PLATE',
  parking_zone:'SECTOR',
  stop:'STOP',
  end:'END',
  parking_auto_stop_option: 'End of day activation',
  parking_zone_verify: 'Please enter your parking zone',

  //  Active

  //  Settings
  user_info: 'PERSONAL INFORMATION',
  mandatory_fields: 'These fields are mandatory',
  enter_account: 'Account',
  enter_email: 'Email',
  enter_phone: 'Phone number',
  enter_license_plate: 'Default license plate',
  address: 'ADDRESS DATA',
  country: 'Country',
  street_and_number: 'Street and number',
  postal_code: 'Postal code',
  city: 'City',

  e_wallet_data: 'E-WALLET DATA',
  license_plate_verify:'Please enter your license plate number',
  street_and_number_verify:'Please enter your street and housenumber',
  postal_code_verify: 'Please enter your postal code',
  city_verify: 'Please enter your city',
  country_verify: 'Please enter your country',

  //  Card data
  create_card: 'Add credit card',
  card_data: 'CARD DATA',
  company: 'Company',
  cardholder: 'Cardholder\'s name',
  card_number: 'Card number',
  expire: 'Expiry date',
  month: 'Month',
  year: 'Year',
  card_cvv: 'Security code',
  auto_top_up_option: 'Automatically top up e-wallet',
  balance_below: 'When balance drops below',
  auto_top_up_value: 'Amount of automatic top up',
  card_number_verify: 'Please enter your card number',
  card_number_digits: 'Please enter the 16 digits of your credit card',
  card_cvv_verify: 'Please enter the security code of your card',
  card_cvv_digits: 'Please enter the 3 digits of your card security code',
  cardholder_verify: 'Please enter the name on your card',
  expiryMonth_verify: 'Please enter the month',
  expiryYear_verify:  'Please enter the year',
  expiryYear_digits: 'Please enter the 4 digits year',


  //  Menu
  your_balance: 'YOUR BALANCE',
  menu_park: 'PARK',
  menu_stop_park: 'STOP PARKING',
  menu_setting: 'SETTING',
  menu_top_up_wallet: 'TOP UP E-WALLET',
  menu_history: 'RECENT TRANSACTIONS',
  user_name:'User Name',

  //TopUpEwallet
  current_balance:'Current balance',
  card_code:'Prepaid card',
  increase_with:'Increase with',
  euro:'euro',
  continue:'CONTINUE',
  pin_code:'PIN code',
  prepaid_card_digits: 'Please enter the 12 digits of your prepaid card',
  pin_code_validate: 'Please enter pin code',

  //History
  amount:'AMOUNT',
  top_up_amount:'Top up amount',
  export_history: 'Export full history to e-mail',

  //Map
  ok: 'OK',
  search: 'Search',

  dey_0: 'Sun',
  dey_1: 'Mon',
  dey_2: 'Tue',
  dey_3: 'Wed',
  dey_4: 'Thu',
  dey_5: 'Fri',
  dey_6: 'Sat',
  max_duration: 'Max. duration',
  price_per_hour: 'Price per hour',

  //  Errors
  error_unknown: 'An error occured during execution!',
  error: 'Error: ',
  error500: 'Internal server error!',
  error502: 'Bad gateway!',
  error503: 'Service temporarily unavailable!',

  // My parkpall----------------------------------------------------------------
  back: 'BACK',

  //login
  login: 'LOG IN',
  no_account: 'No account? Sign up here!',

  //sign up
  email_fld: 'Email',
  pincode_digit_validation: 'PIN must only contain digits',
  phonenumber_req: 'Phone number is required',
  email_req: 'Email is required',

  //settings
  pincode: 'PIN',
  license_plate_fld: 'License plate',
  email_address: 'Email',
  change_settings: 'CHANGE SETTINGS',
  lic_plate_symbol_valid: 'License plate must only contain LATIN characters and digits',

  //info row
  e_wallet: 'E-Wallet',
  log_out: 'Log out',

  //welcome
  welcome: 'WELCOME',
  settings: 'SETTINGS',
  trn_history: 'TRANSACTION HISTORY',

  //top up E-Wallet
  prepaid_card: 'PARKPAL CARD',
  credit_card: 'ONLINE PAYMENT',

  //Transation history
  parking_zone_fld: 'Sector',
  amount_fld: 'Amount',

  //Prepaid CARD
  kiosk_receipt: 'Enter the card number and PIN from your kiosk receipt:',
  with_prepaid_card: 'TOP UP E-WALLET WITH PARKPAL CARD',
  please_enter_pin: 'Please enter your PIN',
  please_enter_card_num: 'Please enter your card number',
  card_number_digit: 'The card number must only contain digits',

  //Credit cardNumber
  with_credit_card: 'TOP UP E-WALLET WITH CREDIT CARD',
  enter_card_data: 'Enter your card data. We do not store these data!',
  terms_and_conditions: 'Terms & Conditions',
  make_payment_but: 'make payment',

  //validationFields
  phone_req: 'Phone number is required',
  pin_req: 'PIN is required',
  licplate_req: 'License plate is required',
  email_req_setting: 'Email is required'

};



// WEBPACK FOOTER //
// ./src/i18n/en.js